export default __webpack_public_path__ + "static/media/D7R.142aacd5.jpg";